<svg
	fill="currentColor"
	xmlns:dc="http://purl.org/dc/elements/1.1/"
	xmlns:cc="http://creativecommons.org/ns#"
	xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
	xmlns:svg="http://www.w3.org/2000/svg"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
	xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
	version="1.1"
	x="0px"
	y="0px"
	width="32px"
	height="32px"
	viewBox="0 0 32 32"
	enable-background="new 0 0 32 32"
	xml:space="preserve"
	id="svg2"
	inkscape:version="0.48.4 r9939"
	sodipodi:docname="view.svg"
	><defs id="defs3255" /><sodipodi:namedview
		pagecolor="#ffffff"
		bordercolor="#666666"
		borderopacity="1"
		objecttolerance="10"
		gridtolerance="10"
		guidetolerance="10"
		inkscape:pageopacity="0"
		inkscape:pageshadow="2"
		inkscape:window-width="640"
		inkscape:window-height="480"
		id="namedview3253"
		showgrid="false"
		inkscape:zoom="7.375"
		inkscape:cx="16"
		inkscape:cy="16"
		inkscape:window-x="53"
		inkscape:window-y="24"
		inkscape:window-maximized="0"
		inkscape:current-layer="svg2"
	/><metadata id="metadata3243"
		><rdf:RDF
			><cc:Work rdf:about=""
				><dc:format>image/svg+xml</dc:format><dc:type
					rdf:resource="http://purl.org/dc/dcmitype/StillImage"
				/><dc:title>PICOL Icon</dc:title><dc:date>2009-03-15</dc:date
				><dc:creator
					><cc:Agent><dc:title>Melih Bilgil</dc:title></cc:Agent></dc:creator
				><dc:rights
					><cc:Agent><dc:title>Creative Commons BY-SA</dc:title></cc:Agent
					></dc:rights
				><dc:publisher
					><cc:Agent
						><dc:title>PICOL - Pictorial Communication Language</dc:title
						></cc:Agent
					></dc:publisher
				><dc:identifier>http://blog.picol.org</dc:identifier><dc:source
					>http://blog.picol.org</dc:source
				><dc:language>en</dc:language><dc:subject
					><rdf:Bag
						><rdf:li>PICOL</rdf:li><rdf:li>icon</rdf:li><rdf:li>icons</rdf:li
						><rdf:li>sign</rdf:li><rdf:li>GUI</rdf:li><rdf:li>vector</rdf:li
						><rdf:li>interface</rdf:li></rdf:Bag
					></dc:subject
				><dc:description>This is one icon out of all PICOL icons</dc:description
				><dc:contributor
					><cc:Agent
						><dc:title
							>Melih Bilgil (www.lonja.de), Christopher Adjei (www.boffer.net)</dc:title
						></cc:Agent
					></dc:contributor
				><cc:license
					rdf:resource="http://creativecommons.org/licenses/by-sa/3.0/"
				/></cc:Work
			><cc:License rdf:about="http://creativecommons.org/licenses/by-sa/3.0/"
				><cc:permits
					rdf:resource="http://creativecommons.org/ns#Reproduction"
				/><cc:permits
					rdf:resource="http://creativecommons.org/ns#Distribution"
				/><cc:requires
					rdf:resource="http://creativecommons.org/ns#Notice"
				/><cc:requires
					rdf:resource="http://creativecommons.org/ns#Attribution"
				/><cc:permits
					rdf:resource="http://creativecommons.org/ns#DerivativeWorks"
				/><cc:requires
					rdf:resource="http://creativecommons.org/ns#ShareAlike"
				/></cc:License
			></rdf:RDF
		></metadata
	><g id="background"
		><rect fill="none" width="32" height="32" id="rect3246" /></g
	><path
		id="path3251"
		d="M 16,6 C 6,6 0,15.938 0,15.938 0,15.938 6,26 16,26 26,26 32,16 32,16 32,16 26,6 16,6 z m 0,18 C 7.25,24 2.5,16 2.5,16 2.5,16 7.25,8 16,8 c 8.75,0 13.5,8 13.5,8 0,0 -4.75,8 -13.5,8 z m 6,-8 c 0,3.313708 -2.686292,6 -6,6 -3.313708,0 -6,-2.686292 -6,-6 0,-3.313708 2.686292,-6 6,-6 3.313708,0 6,2.686292 6,6 z"
	/></svg
>
